import { render, staticRenderFns } from "./VideoSetTime.vue?vue&type=template&id=304489a4&"
import script from "./VideoSetTime.vue?vue&type=script&lang=js&"
export * from "./VideoSetTime.vue?vue&type=script&lang=js&"
import style0 from "./VideoSetTime.vue?vue&type=style&index=0&id=304489a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports